module.exports = __webpack_public_path__ + "img/mosaic.6085de57.svg";